import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import { timezoneToString } from 'modules/core/lib/timezones'

import { useShiftTimeFormatted } from 'modules/shift_management/hooks/useShiftTimeFormatted'
import type { Shift } from 'modules/shift_management/lib/types'

import TooltipIcon from './TooltipIcon'

export interface Props {
  shift: Shift
}

const CustomShiftInformation = ({ shift }: Props) => {
  const formatShiftTime = useShiftTimeFormatted()
  const shiftName = shift.name
  const isOvernightShift = shift.isNightShift
  const isOvertime = shift.isOvertime
  const shiftTimezone = shift.timezone ? timezoneToString(shift.timezone) : null

  return (
    <Box gap="s16" flexDirection="row">
      <Box paddingY="s16">
        <TooltipIcon.Medium
          icon="clock"
          label={i18n.t('shift_management.actions_sidepanel.tooltip.time_period')}
          color="grey700"
        />
      </Box>

      <Box width="full">
        <Box padding="s16" borderRadius={{ all: 'abs016' }} background="grey100" gap="s8">
          {shiftName && (
            <Text.Normal color="grey1000" ellipsis>
              {shiftName}
            </Text.Normal>
          )}
          <Box flexDirection="row" gap="s4" alignItems="center">
            <Text size="200" weight="medium" color="grey1000">
              {formatShiftTime(shift.startTime, shift.endTime)}
            </Text>
            {isOvernightShift && (
              <Text size="200" weight="medium" color="grey1000">
                {i18n.t('shift_management.plus_1_day_tag')}
              </Text>
            )}
          </Box>
          {shiftTimezone && (
            <Text size="200" weight="medium" color="grey1000" ellipsis>
              {shiftTimezone}
            </Text>
          )}
          {isOvertime && (
            <Box flexDirection="row">
              <Tag type="purple">{i18n.t('shift_management.overtime_tag')}</Tag>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default observer(CustomShiftInformation)
